import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import './index.scss';
import App from './App';
import { Provider } from 'react-redux';
import globalStore from './Redux/initStore';
import initI18n, { defaultLanguage } from './locales';
import { ReduxUpdater } from './pdf/ReduxUpdater';
import { SnackbarProvider } from 'notistack';

/**
 * Renders the given content.
 */
function render(): void {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={globalStore}>
                {/* <DefaultBreakpointsProvider>{content}</DefaultBreakpointsProvider> */}
                <SnackbarProvider
                    maxSnack={3}
                    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                    SnackbarProps={{ style: { top: '44px' } }}
                >
                    <App />
                </SnackbarProvider>
            </Provider>
        </React.StrictMode>,
        document.getElementById('root'),
    );
}

initI18n(defaultLanguage).then(() => {
    ReduxUpdater.ribbonRefresh();
});

render();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
